import { Box, Button, Divider, Link, Modal, Stack, Typography } from '@common/components'
import pengguinLogo from '@assets/images/ispeak-grey-logo.png'
import { useTheme } from '@features/theme/theme.hooks'
import { useAuthGoogleGetAuthorizationMutation } from '@app/services/auto-generated/auth'
import { GoogleIcon } from '@common/icons'
import { LOGIN_ROUTE, REGISTER_ROUTE } from '@common/constants/routes'
import { RouterLink, useLocation } from '@lib/router'
import { isUNSW } from '@utils'
import ReactPlayer from 'react-player'
import { useMediaQuery } from '@common/hooks'
import sLoginImg from '@assets/images/slogin_image.png'

interface UnauthHomepageComponentProps {
  url?: string
}

export const UnauthHomepageComponent = (props: UnauthHomepageComponentProps) => {
  const { isDark } = useTheme()
  const isSMDown = useMediaQuery(600)
  const [
    getGoogleAuth,
    { isLoading: isLoadingGetGoogleAuth, isSuccess: isSuccessGoogleAuthLogin },
  ] = useAuthGoogleGetAuthorizationMutation()
  const currentUrl = props.url || window.location.href + '#pricing'
  const location = useLocation()
  const handleGoogleLogin = async () => {
    try {
      const { url } = await getGoogleAuth({
        googleGetAuthorizationRequest: {
          redirect_url: `${window.location.origin}/`,
          ext: {
            realRedirectUrl: props.url || window.location.pathname,
            isStudent: true,
          },
        },
      }).unwrap()
      window.location.href = url
    } catch (error) {}
  }
  return (
    <Stack
      sx={{
        width: '350px',
        maxWidth: '100%',
        borderRadius: '20px',
        padding: '10px',
      }}
      alignItems='center'
      justifyContent='center'
    >
      {location?.pathname.startsWith('/slogin') ? (
        isSMDown ? (
          <img src={sLoginImg} alt={'slogin'} style={{ width: '90%' }} />
        ) : (
          <Box
            sx={{
              maxWidth: '480px',
              width: '100%',
              position: 'relative',
              aspectRatio: '16/9',
              borderRadius: '11px',
              background: 'rgba(230,230,230,0.7)',
              overflow: 'hidden',
              mx: 'auto',
              pointerEvents: 'none',
            }}
          >
            <ReactPlayer
              // volume={0.8}
              playing={true}
              showinfo={false}
              config={{
                youtube: {
                  playerVars: { modestbranding: 0, showinfo: 0, loop: 1 },
                },
              }}
              muted
              url={'/videoplayback.mp4'}
              loop
              // controls
              width='100%'
              height='100%'
              style={{ position: 'absolute', top: 0, left: 0, objectFit: 'cover' }}
            />
          </Box>
        )
      ) : (
        <img
          src={pengguinLogo}
          alt={'pegguin'}
          style={{
            height: '70px',
            transform: 'translateY(2px)',
            filter: isDark && !isUNSW() ? 'invert(1)' : undefined,
            borderRadius: '10px',
          }}
        />
      )}
      <Typography sx={{ fontWeight: '600', marginTop: '30px', fontSize: '20px' }}>
        Welcome to SpeakDuo
      </Typography>
      <Box>
        <Button
          fullWidth
          onClick={handleGoogleLogin}
          variant='outlined'
          color='neutral'
          loading={isLoadingGetGoogleAuth}
          startIcon={<GoogleIcon />}
          sx={{ my: 2, fontWeight: 600, textTransform: 'none' }}
        >
          continue with Google
        </Button>
        {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}> */}
        <Typography variant='body2' sx={{ color: '#B6BBC4', mt: 1 }}>
          Already have an account?{' '}
          <Link underline='hover' component={RouterLink} to={LOGIN_ROUTE}>
            Log in
          </Link>
        </Typography>
        {/* </Box> */}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          width: '240px',
          mt: 4,
          fontSize: '0.9rem',
        }}
      >
        <Link
          underline='hover'
          component={RouterLink}
          to={'https://pengg.notion.site/I-SPEAK-Privacy-Policy-8253f7935d3f4e2bb2176f34c7b0a13b'}
          target='_blank'
          sx={{ color: '#B6BBC4' }}
        >
          Privacy policy
        </Link>
        {/* <Typography sx={{ color: '#B6BBC4' }}>|</Typography> */}
        <Link
          underline='hover'
          component={RouterLink}
          to={
            'https://ispeak.notion.site/Terms-and-Conditions-a07be00c0cb14e728bf66988141055c2?pvs=4'
          }
          target='_blank'
          sx={{ color: '#B6BBC4' }}
        >
          Terms of use
        </Link>
      </Box>
      <Divider sx={{ width: '220px', my: 1 }} />
      <Typography variant='body2' sx={{ color: '#B6BBC4' }}>
        New to SpeakDuo?{' '}
        <Link underline='hover' component={RouterLink} to={REGISTER_ROUTE}>
          Sign up
        </Link>
      </Typography>
    </Stack>
  )
}

export const UnauthHomepageModal = (props) => {
  const { open, onClose } = props
  return (
    <Modal
      open={open}
      onClose={onClose}
      paperProps={{
        sx: { width: '400px', height: '380px' },
      }}
    >
      <UnauthHomepageComponent />
    </Modal>
  )
}
